import React from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const PARTNERS = ['Mutual of Omaha', 'Aetna', 'CVS Health', 'American-Amicable', 'Corebridge Financial', 'Foresters', 'Transamerica', 'Ethos', 'Americo'];

const Footer = ({ scrollToSection }) => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto mb-8">
        <div className="bg-slate-800 p-6 rounded-lg border border-slate-700">
          <p className="text-xs text-slate-400 leading-relaxed">
            <strong className="text-slate-300">{t('footer_disclaimer')}</strong> {t('footer_disclaimer_text')}
          </p>
        </div>
      </div>

      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center mb-4">
              <img src="/solvida-logo-new.png" alt="SolVida Financial" className="h-16 w-auto object-contain" />
            </div>
            <p className="text-slate-400 leading-relaxed">{t('footer_tagline')}</p>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer_quick_links')}</h4>
            <ul className="space-y-2">
              <li><button onClick={() => scrollToSection('products')} className="text-slate-400 hover:text-amber-500 transition-colors duration-200">{t('nav_products')}</button></li>
              <li><button onClick={() => scrollToSection('why-us')} className="text-slate-400 hover:text-amber-500 transition-colors duration-200">{t('nav_why_us')}</button></li>
              <li><button onClick={() => scrollToSection('faq')} className="text-slate-400 hover:text-amber-500 transition-colors duration-200">FAQ</button></li>
              <li><button onClick={() => scrollToSection('contact')} className="text-slate-400 hover:text-amber-500 transition-colors duration-200">{t('nav_contact')}</button></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer_legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy-policy" className="text-slate-400 hover:text-amber-500 transition-colors duration-200">{t('footer_privacy')}</Link></li>
              <li><Link to="/terms-of-service" className="text-slate-400 hover:text-amber-500 transition-colors duration-200">{t('footer_terms')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-bold mb-4">{t('footer_contact_info')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-emerald-500" />
                <a href="mailto:ivonne@solvidafinancial.com" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">ivonne@solvidafinancial.com</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400 text-sm">&copy; {new Date().getFullYear()} {t('footer_copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export { PARTNERS };
export default Footer;
